import React, {Component} from 'react';

import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin); 


class MagicCursor extends Component {
	constructor(props) {
	    super(props);

	    this.state = {
			mouseX: 0,
			mouseY: 0,
			trailingX: 0,
			trailingY: 0,
			hoverables: 'button:not(.is-hover), a[href]:not(.is-hover), .fx-cursor:not(.is-hover), .btn:not(.is-hover)'
	    };
	    this.cursor = React.createRef();
	    this.animationFrame = null;
	    this.hoverables = null;
  	}
  
	componentDidMount() {
		document.addEventListener('mousemove', this.onMouseMove);
		this.addHoverables();
		this.moveCursor();
	}
  	
	componentWillUnmount() {
		document.removeEventListener('mousemove', this.onMouseMove);
		this.removeHoverables();
		cancelAnimationFrame(this.animationFrame);
	}

	addHoverables = () => {
		
		this.hoverables = document.querySelectorAll(this.state.hoverables);
		for (let i = 0; i < this.hoverables.length; i++) {
			this.hoverables[i].classList.add('is-hover');
			this.hoverables[i].addEventListener('mouseenter', evt => {
				document.querySelector('.magic-cursor').classList.add('hover');
			});

			this.hoverables[i].addEventListener('mouseleave', evt => {
				document.querySelector('.magic-cursor').classList.remove('hover');
			});

		}
	}

	removeHoverables = () => {

		for (let i = 0; i < this.hoverables.length; i++) {
			this.hoverables[i].classList.remove('is-hover');
		
		}

	}

	onMouseMove = (evt) => {
		const { clientX, clientY } = evt;
		this.setState({
			mouseX: clientX,
			mouseY: clientY,
		});
	}
  
  	moveCursor = () => {
		const { mouseX, mouseY, trailingX, trailingY } = this.state;
		const diffX = mouseX - trailingX;
		const diffY = mouseY - trailingY;
		//  Number in expression is coeficient of the delay. 10 for example. You can play with it. 
		this.setState({
			trailingX: trailingX + diffX / 10,
			trailingY: trailingY + diffY / 10,
		},
		() => {
			// Using refs and transform for better performance.
			this.cursor.current.style.transform = `translate3d(${trailingX}px, ${trailingY}px, 0)`;
			this.animationFrame = requestAnimationFrame(this.moveCursor);
		});
	}

    render () {

        return (
        <div className="magic-cursor" ref={this.cursor}>
			<div className="magic-cursor__ball"></div>
			<div className="magic-cursor__loader"></div>
		</div>
        );
    }
}

export default MagicCursor;


// WEBPACK FOOTER //
// ./src/components/MagicCursor/MagicCursor.js